<div class="loading-text" [class.d-none]="commonServices.isSkeleton">
    <div>
        <h1 class="animate">Loading</h1>
    </div>
</div>